// @mui
import { useRequest } from 'ahooks';
import classNames from 'classnames';
import { useState } from 'react';

import Empty from '@/components/Empty';

import Pagination from '../pagination';
import { TableProps } from './interface';
import styles from './styles.module.less';
// sections
import TableHead from './TableHead';

// ----------------------------------------------------------------------

export default function Table({ request, rowKey = 'id', columns, theme = '' }: TableProps) {
  const [pages, setPages] = useState({
    current: 1,
    total: 0
  });

  const {
    data,
    // loading,
    runAsync: runQuery
  } = useRequest(request, {
    defaultParams: [
      {
        current: pages.current
      }
    ],
    onSuccess: (res, [{ current = 1 }]) => {
      setPages({
        total: res.total ?? 0,
        current
      });
    }
  });

  // const isNotFound = !data?.data?.length;

  const handleChangePage = current => {
    runQuery({
      current
    });
  };

  return (
    <>
      <div className={styles.box}>
        <table className={classNames(styles.table, theme)}>
          <TableHead columns={columns} />

          <tbody>
            {data?.data?.map((row, rid) => {
              return (
                <tr key={row[rowKey]} tabIndex={-1}>
                  {columns?.map((item, cid) => {
                    const { dataIndex, render, align = 'center' } = item;

                    return (
                      <td align={align} key={`td${rid}_${cid}`}>
                        {render?.(row[dataIndex], row) ?? row[dataIndex]}
                      </td>
                    );
                  })}
                </tr>
              );
            })}
          </tbody>
        </table>
        {data?.data?.length === 0 && <Empty theme={theme} />}
        <div className={styles.paginationbox}>
          <div className={classNames(styles.pagination, theme)}>
            <Pagination total={pages.total} current={pages.current} onChange={handleChangePage} />
          </div>
        </div>
      </div>
    </>
  );
}
